/**
 * @generated SignedSource<<3f670764c69c84a0d91e4768de892708>>
 * @relayHash ee1bd6cb49e1854165e09b99130a59b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 377af4db65b49ba114cb6c2e54913086afe4021507f42ca6cc6702fc2b30f465

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraFieldOptionIdsFilterOperation = "ALLOW" | "EXCLUDE" | "%future added value";
export type JiraFieldOptionIdsFilterInput = {
  operation: JiraFieldOptionIdsFilterOperation;
  optionIds: ReadonlyArray<string>;
};
export type releaseVersionsIssueTransitionIssueAdjustmentsQuery$variables = {
  ari: string;
  filterById?: JiraFieldOptionIdsFilterInput | null | undefined;
};
export type releaseVersionsIssueTransitionIssueAdjustmentsQuery$data = {
  readonly node: {
    readonly id?: string;
    readonly selectableValueOptions?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly selectableGroupKey: string | null | undefined;
          readonly selectableIconUrl: AGG$URL | null | undefined;
          readonly selectableLabel: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type releaseVersionsIssueTransitionIssueAdjustmentsQuery = {
  response: releaseVersionsIssueTransitionIssueAdjustmentsQuery$data;
  variables: releaseVersionsIssueTransitionIssueAdjustmentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ari"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterById"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "ari"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = [
  {
    "kind": "Variable",
    "name": "filterById",
    "variableName": "filterById"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "selectableLabel"
},
v5 = {
  "kind": "ScalarField",
  "name": "selectableGroupKey"
},
v6 = {
  "kind": "ScalarField",
  "name": "selectableIconUrl"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "releaseVersionsIssueTransitionIssueAdjustmentsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "args": (v3/*: any*/),
                "concreteType": "JiraSelectableValueConnection",
                "kind": "LinkedField",
                "name": "selectableValueOptions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSelectableValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "JiraMultipleVersionPickerField"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "releaseVersionsIssueTransitionIssueAdjustmentsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v3/*: any*/),
                "concreteType": "JiraSelectableValueConnection",
                "kind": "LinkedField",
                "name": "selectableValueOptions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSelectableValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v2/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "JiraMultipleVersionPickerField"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "377af4db65b49ba114cb6c2e54913086afe4021507f42ca6cc6702fc2b30f465",
    "metadata": {},
    "name": "releaseVersionsIssueTransitionIssueAdjustmentsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4f26dbdc495633bc3ca79baddd923221";

export default node;
